import React, { useEffect, useState } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { Table } from 'rsuite'
import { useHistory } from 'react-router-dom'
import { ReactComponent as SvgDownload } from '../../../../assets/svg/download.svg'
import LoaderComponent from '../../../CommonComponents/LoaderComponent'
import { getLocationBasedMasterSuppliers } from '../../../../redux/actions/vendor'
import { getAbbreviatedState } from '../../../../services/helper'

const { Column, HeaderCell, Cell, Pagination } = Table
export const LinkCell = ({ rowData, dataKey, onClick, ...props }) => {
  let bgColorClass = rowData[dataKey] === 'Approved' ? 'bg-green' : rowData[dataKey] === 'Rejected' ? 'bg-red' : 'bg-yellow'
  let stateCode = ''
  if (dataKey === 'state') {
    if (rowData?.abbreviatedState === null) {
      stateCode = getAbbreviatedState(rowData?.abbreviatedState, rowData?.state)
    } else {
      stateCode = rowData?.abbreviatedState
    }
  }
  return (
    <Cell {...props} className="table-link">
      {dataKey === 'state' ?
        stateCode
        :
        dataKey === 'supplierQARole' ?
          <h5 style={{ width: '60px' }} className={`btn text-white ${bgColorClass}`}>
            {rowData[dataKey]}
          </h5>
          :
          <button type="button">
            {rowData[dataKey]}
          </button>
      }
    </Cell>
  )
}

export const SelectorCell = ({ rowData, dataKey, onChange, selectedMasterIds, onSelectMaster, onShowChildren, ...props }) => {

  const isSelected = selectedMasterIds && selectedMasterIds.length > 0 ? selectedMasterIds.findIndex(id => id === rowData.id) !== -1 : false
  return (
    <Cell {...props} className="table-action" fixed>
      <div className="button container">
        {
          isSelected ? (
            <button type="button" className="btn btn-green select" onClick={() => onSelectMaster(rowData.id)}>DE SELECT</button>
          ) : (
            <button type="button" className="btn btn-green select" onClick={() => onSelectMaster(rowData.id)}>SELECT</button>
          )
        }
        <button type="button" className="btn btn-gray children" onClick={() => onShowChildren(rowData.id)}>SHOW CHILDREN</button>
      </div>
    </Cell>
  )
}

const LocationMasterRecordComponent = ({ onShowExportModal, tableData, locationMasterSuppliers, onGoToMasterDetail, totalLocationMasterRecords }) => {
  const history = useHistory()
  useEffect(() => {
    history.push('/suppliers')
  }, [])

  const store = useStore().getState()
  const dispatch = useDispatch()
  const {
    app: { masterSupplierTableColumns },
    vendor: { isLoadingLocationMasterSupplier }
  } = store

  const [sortColumn, setSortColumn] = useState('id')
  const [sortType, setSortType] = useState('asc')
  const [limit, setLimit] = React.useState(10)
  const [page, setPage] = React.useState(1)
  const [paginatedTableData, setPaginatedTableData] = useState([])
  const [totalTableRecords, setTableTotalRecords] = useState(0)
  const [locationMasterSupplierColumns, setLocationMasterSupplierColumns] = useState([])

  useEffect(() => {
    let locMasterColumns = [...masterSupplierTableColumns]
    locMasterColumns.splice(1, 0, {
      name: 'primaryMasterSupplierName',
      label: 'Primary Master Supplier Name',
    });
    setLocationMasterSupplierColumns(locMasterColumns)
  }, [])

  useEffect(() => {
    if (!(tableData && tableData.length > 0)) {
      return
    }
    setTableTotalRecords(totalLocationMasterRecords)
    setPaginatedTableData(tableData)
  }, [tableData])

  useEffect(() => {
    setPage(1)
    setTableTotalRecords(totalLocationMasterRecords)
    setPaginatedTableData(tableData)
  }, [totalLocationMasterRecords])

  const handleChangeLimit = dataKey => {
    setPage(1);
    setLimit(dataKey);
    dispatch(getLocationBasedMasterSuppliers({
      limit: dataKey,
      offset: 0
    })).then(res => {
      setPaginatedTableData(res)
    })
  }

  const handleChangePage = (event) => {
    setPage(event)
    dispatch(getLocationBasedMasterSuppliers({
      limit: limit,
      offset: limit * (event - 1)
    })).then(res => {
      setPaginatedTableData(res)
    })
  }

  const handleClickMaster = (masterId) => {
    onGoToMasterDetail(masterId)
  }

  const handleSortTableData = (sortColumn, sortType) => {
    setSortColumn(sortColumn)
    setSortType(sortType)
  }

  const onDownload = (tableData) => {
    const exportData = [locationMasterSupplierColumns.map(column => {
      if (column.name === 'relatedSuppliersCount') {
        return 'Total Related Suppliers'
      } else {
        return column.label
      }
    })]
    exportData.push(...tableData.map(row => {
      return locationMasterSupplierColumns.map(column => row[column.name])
    }))
    onShowExportModal(exportData, 'location_based_master_supplier')
  }

  const headerElement = locationMasterSupplierColumns.map((h, index) => {
    if (index === 0) {
      return (
        <Column
          resizable
          sortable
          key={h.name}
        >
          <HeaderCell>{h.name === 'suppliername' ? 'Location Master Supplier Name' : h.label}</HeaderCell>
          <LinkCell dataKey={h.name} />
        </Column>
      )
    }
    return (
      <Column
        resizable
        sortable
        key={h.name}
      >
        <HeaderCell>{h.label}</HeaderCell>
        {h.name === 'state' ?
          <LinkCell dataKey={h.name} />
          :
          <Cell dataKey={h.name} />
        }
      </Column>
    )
  })

  // add selected master suppliers to search results
  // const tmpTableData = JSON?.parse(JSON?.stringify(tableData))
  // //   if (selectedMasterIds || selectedMasterIds.length > 0) {
  // //     selectedMasterIds.forEach(masterId => {
  // //       if (tmpTableData.findIndex(row => row.id === masterId) === -1) {
  // //         tmpTableData.push(locationMasterSuppliers.find(row => row.id === masterId))
  // //       }
  // //     })
  // //   }
  // const tableDataWithQA = tmpTableData?.map(row => ({
  //   ...row,
  //   supplierQARole: row?.supplierQARole ? row?.supplierQARole : 'Pending'
  // }))

  return (
    <div className={`record-container master-record`}>
      <div className="record-header flex flex-wrap justify-space-between align-center">
        <div className="record-title">
          <span>Location Based Master Supplier Record</span>
        </div>
        <div className="record-toolbar flex flex-wrap align-center">
          <div className="toolbar-item select"></div>
          <div className="toolbar-item flex-wrap gap-2">
            {/* <button className="ms-0 btn-submit h-auto p-3" onClick={handleShowAllChild}>SHOW ALL CHILD VENDORS</button>
            <button className="btn-submit h-auto p-3 ms-0" onClick={onSubmit}>MERGE MASTER RECORDS</button> */}
            <button className="btn-download h-auto p-3 ms-0" onClick={() => onDownload(tableData)}><SvgDownload /></button>
          </div>
        </div>
      </div>
      <div className={`record-body position-relative${isLoadingLocationMasterSupplier ? ' loading' : ''}`}>
        {isLoadingLocationMasterSupplier && <LoaderComponent />}
        <Table
          virtualized
          autoHeight
          affixHeader={true}
          data={paginatedTableData}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={handleSortTableData}
        >
          <Column
            resizable
            sortable
            key='supplierQARole'
          >
            <HeaderCell>QA Status</HeaderCell>
            <LinkCell dataKey='supplierQARole' />
          </Column>

          {headerElement}
        </Table>
        <div className="pagination">
          <Pagination
            prev
            next
            first
            last
            showInfo
            maxButtons={5}
            lengthMenu={[
              {
                label: '5',
                value: 5,
              },
              {
                label: '10',
                value: 10,
              },
              {
                label: '25',
                value: 25,
              },
              {
                label: '50',
                value: 50,
              },
            ]}
            displayLength={limit}
            total={totalTableRecords}
            limit={limit}
            activePage={page}
            onChangePage={(event) => { handleChangePage(event) }}
            onChangeLength={handleChangeLimit}
          />
        </div>
      </div>
    </div>
  )
}
export default LocationMasterRecordComponent